// Croatian catalog. Typed as `Catalog` so a missing or misspelled key is a
// compile-time error; keep it in sync with `catalog-en.ts`.
//
// Croatian uses `one` for 1 and numbers ending in 1 (except 11), and `other`
// for the rest of the plural forms via `Intl.PluralRules('hr')`.

import type { Catalog } from './messages';

export const hr: Catalog = {
  app: {
    name: 'Sensing',
    tagline: 'Bilježnica za tvoje senzore',
  },
  home: {
    lede: 'Očitanja senzora o kojima se brineš, na jednom mjestu.',
    accountHint: 'Prijava ide preko Googlea ili Applea. Ovdje se ne stvara lozinka.',
    signIn: 'Prijavi se',
    aboutLink: 'O aplikaciji Sensing',
  },
  about: {
    title: 'O aplikaciji Sensing',
    lede: 'Sensing je web-aplikacija za čitanje, organiziranje i održavanje senzora o kojima se brineš. Pratiš što prijavljuju i mijenjaš kako to rade.',
    whatTitle: 'Što radi',
    whatBody:
      'Račun posjeduje izvore: ESP32 uređaje sa senzorima, fiksne senzore dostupne preko pristupnika i vanjske izvore koji šalju vlastite podatke. Aplikacija pokazuje što koji izvor prijavljuje i omogućuje vlasniku da to prilagodi.',
    capability_feeds:
      'Nadzorna ploča sa svakim kanalom računa: najnovija vrijednost i nedavna povijest, kao grafikon ili popis očitanja.',
    capability_groups:
      'Grupe koje opisuju mjesto, podijeljene na dijelove poput prostorija, koje se mogu podijeliti samo za čitanje vezom s jednokratnom pozivnicom.',
    capability_devices:
      'Konfiguracija uređaja na daljinu: koliko često šalje podatke, koje module pokreće, vremenska zona i Wi-Fi mreže.',
    capability_external:
      'Vanjski izvori, za podatke koji stižu preko HTTP-a ili MQTT-a s nečega što nije Sensing uređaj.',
    capability_sensors:
      'Uparivanje Zigbee i Bluetooth senzora preko pristupnika koji pokreće odgovarajući modul mosta.',
    accountTitle: 'Tvoj račun',
    accountBody:
      'Prijava ide preko Googlea ili Applea; ovdje se ne stvara lozinka i ne šalje se e-pošta. Račun služi tome da uređaji i očitanja svakog vlasnika ostanu odvojeni od tuđih.',
    backHome: 'Natrag na početak',
  },
  legal: {
    privacyLink: 'Pravila privatnosti',
    termsLink: 'Uvjeti korištenja',
    privacyTitle: 'Pravila privatnosti',
    termsTitle: 'Uvjeti korištenja',
    updated: 'Ažurirano {date}',
    contact: 'Pitanja o ovoj stranici: {email}',
    privacy_who_title: 'Tko je odgovoran',
    privacy_who_body:
      'Uslugu Sensing pruža operater instalacije koju koristiš. Ova stranica opisuje što ta usluga pohranjuje i zašto. Operater je voditelj obrade tih podataka.',
    privacy_google_title: 'Što dobivamo od Googlea ili Applea',
    privacy_google_body:
      'Ako se prijaviš Googleom, Google nam javlja stalni identifikator tvog Google računa, adresu e-pošte, je li ta adresa potvrđena te tvoje ime i sliku profila ako ih račun ima. Tražimo samo ovlasti openid, email i profile. Ne tražimo pristup Gmailu, Driveu, Kalendaru, kontaktima ni drugoj Google usluzi i nikada ne vidimo tvoju Google lozinku. Ako se prijaviš Appleom, Apple nam javlja stalni identifikator, adresu e-pošte (to može biti privatna adresa za prosljeđivanje koju Apple stvori za tebe) i tvoje ime pri prvoj prijavi. Čuvamo identifikator, adresu e-pošte, je li potvrđena i ime; sliku ne čuvamo.',
    privacy_collected_title: 'Što usluga pohranjuje',
    privacy_collected_body:
      'Osim onoga što vrati pružatelj prijave, usluga pohranjuje što je potrebno za rad:',
    privacy_collected_account:
      'Tvoj račun: identifikator pružatelja, adresu e-pošte, je li adresa potvrđena i tvoje ime. Nikada lozinku.',
    privacy_collected_readings:
      'Izvore koje posjeduješ i očitanja koja šalju: ključeve kanala, vrijednosti, jedinice, vrijeme opažanja i zaprimanja te oznaku kvalitete vremena.',
    privacy_collected_devices:
      'Zapise o uređajima: javni identifikator, verziju hardvera i firmvera, prijavljeno stanje, certifikate i konfiguraciju koju si zatražio.',
    privacy_collected_wifi:
      'Nazive Wi-Fi mreža koje uređaj prijavljuje i lozinke koje za njih upišeš. Lozinke se šifriraju u tvom pregledniku ključem koji uređaj objavljuje, pa usluga pohranjuje šifrat koji ne može pročitati.',
    privacy_collected_technical:
      'Tehničke zapise: hash tokena sesije u kolačiću, revizijske zapise administrativnih radnji i brojčane metrike koje ne sadrže identitet računa.',
    privacy_purpose_title: 'Zašto ih koristimo',
    privacy_purpose_body:
      'Da te prijavimo i održimo sesiju, da ti pokažemo tvoje podatke i ničije tuđe, da dostavimo konfiguraciju tvojim uređajima, da usluga radi i bude sigurna te da ti odgovorimo kad nas kontaktiraš. Googleove podatke ne koristimo za oglašavanje, profiliranje ni treniranje modela strojnog učenja i ne prodajemo ih.',
    privacy_stored_title: 'Gdje se čuvaju',
    privacy_stored_body:
      'Poslužitelji i baza podataka usluge nalaze se u Europskoj uniji. Cloudflare dostavlja web-aplikaciju i prosljeđuje tvoje zahtjeve tim poslužiteljima, a Google ili Apple obavlja prijavu koju odabereš. Te tvrtke mogu obrađivati podatke u Sjedinjenim Američkim Državama, prema Okviru za privatnost podataka EU–SAD ili standardnim ugovornim klauzulama Europske komisije. Podaci se prenose preko HTTPS-a i MQTT-a preko TLS-a. Lozinke za Wi-Fi čuvaju se šifrirane kako je opisano, a tajne prijave i privatni ključevi uređaja drže se izvan baze podataka aplikacije.',
    privacy_cookies_title: 'Kolačići i lokalna pohrana',
    privacy_cookies_body:
      'Usluga postavlja kolačić sesije, koji je HttpOnly i Secure, CSRF kolačić i, dok se prijavljuješ, kolačić prijave koji istječe unutar 10 minuta. Sva tri su potrebna za prijavu i slanje obrazaca i nijedan se ne koristi za oglašavanje ni analitiku. Postavke jezika i izgleda te poveznica pozivnice koju si otvorio prije prijave čuvaju se u pohrani preglednika i nikada se ne šalju poslužitelju. Na nijednoj stranici nema analitike, oglašavanja ni praćenja trećih strana.',
    privacy_sharing_title: 'Tko ih još vidi',
    privacy_sharing_body:
      'Tvoje podatke ne prodajemo i ne dijelimo za oglašavanje. Do drugih dolaze samo u ovim slučajevima:',
    privacy_sharing_processors:
      'Tvrtke koje za operatera obavljaju dijelove usluge: pružatelj hostinga, Cloudflare te Google ili Apple za prijavu koju odabereš. Postupaju po uputama operatera.',
    privacy_sharing_legal:
      'Kad to zakon zahtijeva ili radi zaštite usluge i njezinih korisnika od zlouporabe.',
    privacy_sharing_noAds: 'Nikada oglašivačima, posrednicima s podacima ni ikome tko o tebi gradi profil.',
    privacy_retention_title: 'Koliko dugo se čuvaju',
    privacy_retention_body:
      'Očitanja se čuvaju dok ih ne izbrišeš: tok, raspon očitanja, izvor ili cijeli račun. Izvor koji ukloniš može zadržati povijest u arhivi koju još možeš čitati i brisati. Brisanje računa odmah uklanja sve što posjeduje i oslobađa njegove uređaje; u revizijskom dnevniku ostaje samo interni broj računa, bez tvog imena i e-pošte, kako bi se vidjelo tko je što promijenio. Zapisi sesije istječu nakon 7 dana neaktivnosti ili 30 dana ukupno, a zapisi o ulazu koji je usluga morala odbiti nakon 30 dana.',
    privacy_rights_title: 'Tvoje mogućnosti',
    privacy_rights_body:
      'Prema GDPR-u imaš ova prava. Dva su u aplikaciji, pod Račun: Preuzmi moje podatke daje ti kopiju svega što račun sadrži, u strojno čitljivoj datoteci, a Izbriši račun ga briše. Za sve ostalo piši na adresu ispod:',
    privacy_rights_access:
      'Saznaj koji se podaci o tebi čuvaju i dobij njihovu kopiju (Preuzmi moje podatke, u aplikaciji).',
    privacy_rights_correct: 'Ispravi što je netočno.',
    privacy_rights_delete: 'Izbriši svoj račun i podatke vezane uz njega (Izbriši račun, u aplikaciji).',
    privacy_rights_object: 'Uloži prigovor na korištenje tvojih podataka ili zatraži njihovo ograničenje.',
    privacy_rights_complain:
      'Prijavi se nadzornom tijelu. U Hrvatskoj je to Agencija za zaštitu osobnih podataka (AZOP).',
    privacy_children_title: 'Djeca',
    privacy_children_body:
      'Usluga nije namijenjena djeci mlađoj od 16 godina i svjesno im ne stvaramo račune.',
    privacy_changes_title: 'Promjene',
    privacy_changes_body:
      'Ako se ova pravila promijene, mijenja se i datum na vrhu. Bitna promjena objavljuje se u aplikaciji prije stupanja na snagu.',
    terms_service_title: 'Usluga',
    terms_service_body:
      'Sensing je hostana aplikacija za nadzor i održavanje senzora. Nudi se takva kakva jest, za vlastitu upotrebu operatera i za račune koje operater odobri.',
    terms_account_title: 'Tvoj račun',
    terms_account_body:
      'Prijavljuješ se preko Googlea ili Applea i odgovoran si za aktivnost pod svojim računom. Odmah obavijesti operatera ako smatraš da netko drugi ima pristup.',
    terms_use_title: 'Prihvatljivo korištenje',
    terms_use_body: 'Slažeš se da nećeš:',
    terms_use_lawful: 'Koristiti uslugu nezakonito ni čuvati podatke na koje nemaš pravo.',
    terms_use_access:
      'Pokušavati doći do podataka drugog računa ni zaobilaziti provjere prijave i ovlasti koje usluga primjenjuje.',
    terms_use_devices: 'Upravljati uređajima tako da ugroziš ljude, imovinu ili mrežu na koju se spajaju.',
    terms_data_title: 'Tvoji podaci',
    terms_data_body:
      'Tvoja očitanja i konfiguracija uređaja ostaju tvoji. Možeš ih izbrisati u svakom trenutku; pravila privatnosti objašnjavaju što brisanje uklanja, a što ostaje.',
    terms_availability_title: 'Dostupnost i promjene',
    terms_availability_body:
      'Usluga se pruža bez jamstva neprekinute dostupnosti. Značajke se mogu mijenjati, a ažuriranje uređaja može nakratko prekinuti očitanja. Planirani prekidi objavljuju se kad operater to može.',
    terms_liability_title: 'Odgovornost',
    terms_liability_body:
      'U mjeri u kojoj zakon dopušta, operater ne odgovara za neizravnu ili posljedičnu štetu nastalu korištenjem usluge, uključujući gubitak očitanja. Ovo ne ograničava odgovornost koja se zakonom ne može ograničiti.',
    terms_changes_title: 'Promjene ovih uvjeta',
    terms_changes_body:
      'Ako se ovi uvjeti promijene, mijenja se i datum na vrhu, a bitna promjena objavljuje se u aplikaciji prije stupanja na snagu.',
  },
  nav: {
    dashboard: 'Tokovi podataka',
    groups: 'Grupe',
    sources: 'Izvori',
    manage: 'Upravljanje',
    admin: 'Administracija',
    account: 'Račun',
    signOut: 'Odjava',
    refresh: 'Osvježi',
    back: 'Natrag',
    menu: 'Izbornik',
    primaryNavigation: 'Glavna navigacija',
    manageNavigation: 'Navigacija za upravljanje',
    tabs: {
      feeds: 'Tokovi',
      groups: 'Grupe',
      sources: 'Izvori',
      admin: 'Admin',
      account: 'Račun',
    },
  },
  dashboard: {
    title: 'Tokovi podataka',
    description: 'Najnovija očitanja sa svakog kanala ovog računa.',
    noChannels: 'Za ovaj izvor još nema kanala.',
    noDatastream: 'Još nema očitanja. Kanal dobiva svoj tok podataka iz prvog zaprimljenog uzorka.',
    openReadings: 'Otvori očitanja',
    latest: 'Posljednje',
    recentPoints: 'Najnovijih {count} očitanja, od najstarijeg.',
    partial: 'Prikazano {shown} od {total} kanala.',
    sourcesError: 'Nije moguće učitati izvore za ovaj račun.',
  },
  common: {
    loading: 'Učitavanje…',
    retry: 'Pokušaj ponovno',
    retryingAutomatically: 'Automatski pokušavam ponovno…',
    error: 'Nešto je pošlo po zlu',
    empty: 'Ovdje još nema ničega',
    save: 'Spremi',
    saving: 'Spremanje…',
    cancel: 'Odustani',
    close: 'Zatvori',
    copy: 'Kopiraj',
    copied: 'Kopirano u međuspremnik',
    copyFailed: 'Kopiranje nije uspjelo; označi tekst i kopiraj ga ručno',
    confirm: 'Potvrdi',
    dismiss: 'Odbaci',
    details: 'Pojedinosti',
    showDetails: 'Prikaži pojedinosti',
    hideDetails: 'Sakrij pojedinosti',
    unknown: 'Nepoznato',
    none: 'Nema',
    notAvailable: 'Nije dostupno',
    yes: 'Da',
    no: 'Ne',
    lastUpdated: 'Posljednje osvježenje {time}',
    staleData: 'Prikazuju se podaci od {time}; mogu biti zastarjeli',
    refreshing: 'Osvježavanje…',
    forbiddenTitle: 'Nije dostupno ovom računu',
    forbiddenBody: 'Nemaš pristup ovom zaslonu.',
    loadMore: 'Učitaj više',
    of: 'od',
  },
  theme: {
    label: 'Izgled',
    light: 'Svijetlo',
    black: 'Crno',
    system: 'Sustav',
  },
  language: {
    label: 'Jezik',
    en: 'Engleski',
    hr: 'Hrvatski',
  },
  auth: {
    title: 'Prijava',
    subtitle: 'Koristi račun kojem pripadaju tvoji uređaji.',
    continueWithProvider: 'Nastavi s {provider}',
    providerUnavailable: 'Ovaj način prijave nije konfiguriran za ovu instalaciju.',
    noProviders: 'Nijedan način prijave nije konfiguriran. Obrati se operatoru usluge.',
    error: 'Prijava nije dovršena. Pokušaj ponovno.',
    awaitingApprovalTitle: 'Čeka odobrenje',
    awaitingApproval:
      'Račun je stvoren. Sensing je u zatvorenoj beti, pa ga administrator mora odobriti prije nego što se možeš prijaviti.',
    cancelled: 'Prijava je otkazana.',
    expired: 'Tvoja sesija je istekla. Prijavi se ponovno.',
    signOutConfirmTitle: 'Odjava?',
    signOutConfirmBody: 'Za pristup svojim izvorima morat ćeš se ponovno prijaviti.',
    signedOut: 'Odjavljeni ste',
  },
  account: {
    dataTitle: 'Tvoji podaci',
    exportBody:
      'Preuzmi sve što ovaj račun sadrži kao jednu JSON datoteku: identitete prijave, izvore, grupe i sva očitanja.',
    exportButton: 'Preuzmi moje podatke',
    deleteBody:
      'Brisanje računa uklanja njega i sve što posjeduje, odmah i zauvijek: očitanja, izvore, grupe i dijeljenja. Uređaji se oslobađaju i resetiraju, pa ih netko drugi može preuzeti. Zapis da je račun postojao, bez tvog imena i e-pošte, ostaje u revizijskom dnevniku.',
    deleteButton: 'Izbriši račun',
    deleteTitle: 'Izbrisati ovaj račun?',
    deleteConfirmBody:
      'Ovo se ne može poništiti. Ako ih želiš zadržati, prvo preuzmi svoje podatke. Upiši {word} za potvrdu.',
    deleteWord: 'IZBRIŠI',
    deleteConfirmLabel: 'Potvrda',
    deleteWhileImpersonating:
      'Račun se ne može izbrisati dok djeluješ kao on; izbriši ga na administratorskoj stranici.',
    deleteLastAdmin: 'Ti si jedini administrator. Prvo postavi drugi račun za administratora.',
    title: 'Račun',
    description: 'Identitet tvoje sesije i lokalne postavke.',
    userId: 'Aktivni račun',
    actorUserId: 'Vlasnik sesije',
    sessionId: 'Sesija',
    role: 'Uloga',
    roleOwner: 'Vlasnik',
    roleAdmin: 'Administrator',
    impersonating: 'Predstavljanje',
    preferencesNote: 'Jezik i izgled spremaju se samo u ovom pregledniku.',
  },
  sources: {
    archived: 'Uklonjeno',
    archivedHint: 'Povijest izvora koje ste uklonili. Otvorite jedan da ga pročitate ili obrišete.',
    title: 'Izvori',
    description: 'Uređaji i vanjski izvori podataka ovog računa.',
    empty: 'Još nema izvora',
    emptyHint: 'Dodaj uređaj pomoću koda za uparivanje ili stvori vanjski izvor.',
    addDevice: 'Dodaj uređaj',
    addExternal: 'Stvori vanjski izvor',
    kindDevice: 'Uređaj',
    kindExternal: 'Vanjski izvor',
    kindLabel: 'Vrsta',
    stateActive: 'Aktivan',
    stateDisabled: 'Onemogućen',
    stateRetired: 'Povučen',
    statusLabel: 'Status',
    nameLabel: 'Naziv',
    unnamed: 'Neimenovani izvor',
  },
  source: {
    archive: 'Uklonjeni izvor: njegova povijest',
    archiveHint:
      'Ovo je povijest izvora koji ste uklonili. Ništa mu se više ne dodaje. Možete je čitati, preimenovati ili obrisati.',
    archivedStreams: 'Tokovi',
    inactive: 'Više se ne javlja',
    inactiveHint:
      'Izvor ih više ne šalje, na primjer jer je modul uklonjen. Njihova povijest ostaje dok je ne obrišete.',
    title: 'Izvor',
    channels: 'Kanali',
    channelsEmpty: 'Za ovaj izvor još nema deklariranih kanala.',
    channelsEmptyHint: 'Kanali se pojavljuju kada ih izvor deklarira.',
    channelCount: { one: '{count} kanal', other: '{count} kanala' },
    device: 'Uređaj',
    deviceDetails: 'Pojedinosti uređaja',
    externalFeed: 'Vanjski izvor',
    noReadingsYet: 'Još nema očitanja',
    selectChannel: 'Odaberi kanal za prikaz njegovih očitanja.',
    rename: 'Preimenuj',
    renameTitle: 'Preimenuj',
    nameLabel: 'Naziv',
    nameHelp: 'Prikazuje se u popisima i na nadzornoj ploči. Ostavi prazno za brisanje.',
    renamed: 'Naziv spremljen',
  },
  device: {
    firmware: {
      title: 'Firmver',
      running: 'Pokreće',
      notReported: 'Još nije prijavljen',
      upToDate: 'Ažuran.',
      available: 'Dostupna je verzija {version}.',
      availableHint:
        'Oko {size} KiB. Uređaj je preuzima u pozadini, ponovno se pokreće s njom i zadržava je samo ako se ispravno pokrene.',
      update: 'Ažuriraj na {version}',
      confirmTitle: 'Ažurirati na {version}?',
      confirmBody:
        'Uređaj preuzima ažuriranje kad sljedeći put bude na mreži, a zatim se ponovno pokreće. Izlazi se isključuju i mjerenja pauziraju tijekom ponovnog pokretanja. Ako se novi firmver ne pokrene ispravno, uređaj se sam vraća na {running}.',
      stageWaiting: 'Zatraženo ažuriranje na {version}. Uređaj ga preuzima kad sljedeći put bude na mreži.',
      stageDownloading: 'Preuzimanje verzije {version}…',
      stageInstalling: 'Instalacija verzije {version}; uređaj se ponovno pokreće.',
      stageConfirming: '{version} je pokrenuta; čeka se da je uređaj prijavi.',
      stageFailed: 'Ažuriranje na {version} nije dovršeno ({reason}). Uređaj je zadržao svoj firmver.',
      reasonUnknown: 'bez navedenog razloga',
      failedHint: 'Ovo izdanje ne može se ponovno ponuditi ovom uređaju; novije može.',
    },
    classConfigurable: 'Konfigurabilni uređaj',
    classFixed: 'Fiksni senzor',
    statusTitle: 'Status',
    reported: 'Status je prijavljen',
    notReported: 'Status još nije prijavljen',
    stateAwake: 'Budan',
    stateSleeping: 'Spava',
    stateDisconnected: 'Odspojen',
    operationMode: 'Način rada',
    modeDeepSleep: 'Duboki san',
    modeAlwaysOn: 'Stalno uključen',
    receivedAt: 'Status zaprimljen',
    lastContactAt: 'Posljednji stvarni kontakt',
    neverContacted: 'Nema potvrđenog stvarnog kontakta',
    retainedReplay: 'Zadržan ili ponovno poslan status',
    freshnessNote: 'Nedavno zaprimanje ili uključen pristupnik ne dokazuje da je senzor sada dostupan.',
    deepSleepNote: 'Duboki san je očekivano stanje, a ne kvar. Uređaj se budi po zadanoj dinamici.',
    fixedNote: 'Fiksni senzori nemaju konfiguraciju, module ni naredbe.',
    hardwareRevision: 'Revizija hardvera',
    ownedSince: 'U vlasništvu od',
  },
  readings: {
    title: 'Očitanja',
    description: 'Najnovija očitanja prva. Jedna stranica nije cijela povijest.',
    empty: 'Još nema očitanja',
    emptyHint: 'Očitanja se pojavljuju nakon što izvor pošalje prvi uzorak.',
    noDatastream: 'Ovaj kanal još nema očitanja. Njegov tok podataka stvara prvi uzorak.',
    tableView: 'Tablica',
    chartView: 'Grafikon',
    chartTitle: 'Povijest',
    chartHint: 'Povuci klizač za povećanje. Tablica zadržava svoje stranice.',
    chartBooleanHint:
      'Logička vrijednost je stanje. Linija ostaje ravna dok je sljedeći uzorak ne promijeni.',
    chartNonNumeric:
      'Tekstualne vrijednosti nemaju oblik kroz vrijeme pa je ovaj kanal prikazan samo kao vrijednosti.',
    chartNotEnoughPoints: 'Nema dovoljno očitanja u ovom rasponu za grafikon.',
    chartNoPoints: 'Nema očitanja u ovom rasponu.',
    rangeEmpty: 'Nema očitanja u ovom rasponu. Pokušaj dulji raspon.',
    rangeLabel: 'Raspon',
    range_1h: '1 h',
    range_6h: '6 h',
    range_24h: '24 h',
    range_7d: '7 d',
    range_30d: '30 d',
    range_all: 'Sve',
    rangeSummary: '{count} točaka u posljednjih {range}.',
    rangeAllSummary: '{count} točaka, od najnovije prema starijima.',
    rangeTruncated: 'Prikazano je najnovijih {count} točaka; odaberi kraći raspon za cijeli prikaz.',
    columnChannel: 'Kanal',
    columnValue: 'Vrijednost',
    columnUnit: 'Jedinica',
    columnObservedAt: 'Opaženo',
    columnIngestedAt: 'Zaprimljeno',
    columnQuality: 'Kvaliteta vremena',
    qualitySynchronized: 'Sinkronizirano',
    qualityEstimated: 'Procijenjeno',
    qualityUnknown: 'Nepoznato',
    observationUnknown: 'Vrijeme opažanja nepoznato',
    observationUnknownHint: 'Izvor nije poslao kada je očitanje nastalo; poznato je samo vrijeme zaprimanja.',
    observationEstimated: 'Procijenjeno vrijeme opažanja',
    ingestedNote: 'Vrijeme zaprimanja je trenutak kada je pozadina spremila očitanje.',
    pageNote: 'Učitano {count} očitanja. Možda postoji još podataka.',
    previousPage: 'Prethodno',
    booleanTrue: 'Točno',
    booleanFalse: 'Netočno',
  },
  groups: {
    title: 'Grupe',
    description:
      'Organiziraj tokove podataka u grupe za mjesta, poput kuće ili polja, i podijeli ih s drugima za pregled.',
    empty: 'Još nema grupa',
    emptyHint: 'Stvori grupu, zatim joj dodaj tokove.',
    nameLabel: 'Naziv grupe',
    namePlaceholder: 'Staklenik',
    nameInvalid: 'Koristi od 1 do 64 znaka.',
    create: 'Stvori grupu',
    creating: 'Stvaranje…',
    feedCount: { one: 'Tokova: {count}', other: 'Tokova: {count}' },
    loading: 'Učitavanje grupa…',
    notFound: 'Ova grupa ne postoji ili je ne posjeduješ niti pregledavaš.',
    delete: 'Izbriši grupu',
    deleteConfirm: 'Izbrisati ovu grupu? Tokovi i očitanja ostaju sačuvani.',
    feeds: 'Tokovi u ovoj grupi',
    noFeeds: 'Ova grupa još nema tokova.',
    addFeed: 'Dodaj tok',
    addFeedPlaceholder: 'Odaberi tok',
    add: 'Dodaj',
    remove: 'Ukloni {name} iz ove grupe',
    allAdded: 'Svi tvoji tokovi već su u ovoj grupi.',
    noOwnedFeeds: 'Tokovi se ovdje pojavljuju kad izvor pošalje prvo očitanje.',
    back: 'Sve grupe',
    noFeedsHint: 'Dodaj tokove na kartici Tokovi.',
    noSection: 'Ostalo',
    locationLabel: 'Lokacija',
    locationPlaceholder: 'Zagreb, Ilica 1',
    descriptionLabel: 'Opis',
    descriptionPlaceholder: 'Što je ovo mjesto',
    saveDetails: 'Spremi podatke',
    sectionLabel: 'Odjeljak',
    sectionPlaceholder: 'Spavaća soba',
    sectionOf: 'Odjeljak za {name}',
    leave: 'Prestani pregledavati',
    leaveConfirm: 'Prestati pregledavati ovu grupu? Za ponovni pristup trebat ćeš novu pozivnicu.',
    tabOverview: 'Pregled',
    tabFeeds: 'Tokovi',
    tabDetails: 'Podaci',
    tabSharing: 'Dijeljenje',
    sharedTitle: 'Podijeljeno s tobom',
    sharedBy: 'Dijeli {name}',
    sharedWithYou: 'Podijeljeno s tobom',
    viewerCount: { one: 'Podijeljeno s osoba: {count}', other: 'Podijeljeno s osoba: {count}' },
  },
  sharing: {
    title: 'Podijeli ovu grupu',
    description:
      'Pozivnica omogućuje jednoj osobi da pregledava ovu grupu: njezine podatke, tokove i očitanja, nikad tvoje uređaje ni njihove postavke. Tokovi koje kasnije dodaš također se dijele. Poveznica vrijedi jednom i istječe za sedam dana.',
    createLink: 'Stvori pozivnicu',
    newLink: 'Nova pozivnica',
    newLinkHint: 'Pošalji je osobi koju pozivaš. Prikazuje se samo sada i vrijedi do {date}.',
    copy: 'Kopiraj',
    copied: 'Kopirano',
    openLinks: 'Otvorene pozivnice',
    noOpenLinks: 'Nema otvorenih pozivnica.',
    linkCreated: 'Stvorena {date}',
    linkExpires: 'Istječe {date}',
    cancelLink: 'Poništi ovu pozivnicu',
    viewers: 'Osobe koje pregledavaju ovu grupu',
    noViewers: 'Nitko drugi ne pregledava ovu grupu.',
    unnamedViewer: 'Račun bez imena',
    viewerSince: 'od {date}',
    removeViewer: 'Ukloni {name}',
    removeViewerConfirm: 'Ukloniti {name}? Odmah prestaje vidjeti ovu grupu.',
  },
  invite: {
    title: 'Pozivnica u grupu',
    body: '{owner} te poziva da pregledavaš grupu „{group}”.',
    someone: 'Netko',
    disclosure:
      'Ako prihvatiš, {owner} će vidjeti tvoje ime i e-poštu. Pregledavanje možeš prekinuti bilo kada.',
    expires: 'Ova pozivnica vrijedi jednom i do {date}.',
    accept: 'Prihvati i otvori',
    openGroup: 'Otvori grupu',
    decline: 'Ne sada',
    ownGroup: 'Ovo je tvoja grupa, pa nema što prihvatiti.',
    closed: 'Ova pozivnica više ne vrijedi',
    closedHint: 'Iskorištena je, poništena ili je istekla. Zatraži novu poveznicu.',
    pasteAnother: 'Upotrijebi drugu poveznicu',
    noLink: 'Otvori primljenu pozivnicu ili je zalijepi ovdje.',
    pasteLabel: 'Pozivnica',
    pastePlaceholder: 'https://…/invite#…',
    pasteInvalid: 'Ovo nije pozivnica.',
    open: 'Otvori pozivnicu',
    installFirst:
      'Ovo je pozivnica u grupu. Instaliraj aplikaciju, prijavi se, pa zalijepi pozivnicu na stranici Grupe.',
    copyLink: 'Kopiraj pozivnicu',
  },
  modules: {
    title: 'Moduli',
    action: 'Moduli',
    intro:
      'Moduli su ono što uređaj radi: svaki očitava senzor, upravlja izlazom ili izvodi logiku. Dodaj ih iz kataloga ispod, podesi ih i spremi da uređaju pošalješ novu reviziju.',
    selected: 'Na ovom uređaju',
    none: 'Još nema modula',
    noneHint: 'Dodaj jedan iz kataloga ispod.',
    available: 'Dodaj modul',
    availableEmpty: 'Svi moduli iz kataloga već su na ovom uređaju.',
    catalogEmpty: 'Katalog je prazan. Administrator objavljuje module u Administraciji.',
    add: 'Dodaj',
    remove: 'Ukloni',
    enabled: 'Uključen',
    version: 'Verzija {version}',
    update: 'Ažuriraj na {version}',
    builtIn: 'Ugrađen u firmver',
    needsAwake: 'Drži uređaj budnim',
    switchesMode:
      'Spremanje uređaj prebacuje i na stalno uključen način rada, jer ga {name} treba stalno budnog.',
    instanceTitle: 'Kopija',
    instanceLabel: 'Naziv ove kopije',
    instanceHelp:
      'Razlikuje kopije istog modula, na primjer „vani”. Mala slova, znamenke, - i _. Očitanja se spremaju pod tim nazivom, pa preimenovanje pokreće nove tokove.',
    instanceInvalid:
      'Svaka kopija treba svoj naziv: do 15 malih slova, znamenki, - ili _, s malim slovom ili znamenkom na početku.',
    scheduleTitle: 'Koliko često',
    minInterval: 'Očitaj najviše svakih (minuta)',
    minIntervalHint:
      'Uređaj očitava sve svoje module jednom u svakom intervalu očitanja (kartica Rad). Uz vrijednost ovdje preskače ovaj modul dok od njegova zadnjeg očitanja ne prođe toliko minuta, pa je razmak višekratnik intervala očitanja: 60 minuta uz interval od 15 minuta znači svako četvrto očitanje.',
    minIntervalEvery: 'U svakom intervalu očitanja',
    settings: 'Postavke',
    signals: 'Ulazi',
    signalHelp: 'Očitanje drugog modula na ovom uređaju koje ovaj ulaz koristi.',
    signalNone: 'Nije povezano',
    signalNoChoices: 'Nijedan modul na ovom uređaju ne daje odgovarajuće očitanje.',
    pins: 'Pinovi',
    pinSda: 'SDA pin',
    pinScl: 'SCL pin',
    busSpeed: 'Brzina sabirnice (Hz)',
    pin: 'Pin',
    pinOptional: 'Nije obavezno. Ostavi prazno ako ovaj modul ne treba upravljati pinom.',
    jsonInvalid: 'Još nije ispravan JSON; zadržava se zadnja ispravna vrijednost.',
    jsonNeedsObject: 'Potreban je JSON objekt, u vitičastim zagradama.',
    jsonNeedsArray: 'Potreban je JSON niz, u uglatim zagradama.',
    edge: 'Broji impulse na',
    edgeRising: 'Rastućem bridu',
    edgeFalling: 'Padajućem bridu',
    edgeBoth: 'Oba brida',
    unsupportedPort: 'Ova vrsta porta ne može se ovdje dodijeliti.',
    notInCatalog: 'Nije u katalogu; pri spremanju ostaje nepromijenjen.',
    deviceState: 'Uređaj: {state}',
    readings: 'Javlja: {list}',
    tooMany: 'Najviše {count} modula može biti uključeno istovremeno.',
    save: 'Spremi module',
    saving: 'Spremanje…',
    saved: 'Spremljeno kao revizija {revision}. Uređaj je instalira kad se sljedeći put probudi.',
    savedAlwaysOn: 'Spremljeno kao revizija {revision}. Uređaj je povezan i instalira je u nekoliko sekundi.',
    unchanged: 'Nema promjena za spremanje.',
    failed:
      'Uređaj odbija reviziju {revision} jer je već nije uspio primijeniti. Kad ukloniš uzrok, ponovno pošalji iste module kao novu reviziju.',
    resend: 'Pošalji ponovno',
    zigbeeHint: 'Kad ovaj most radi na uređaju, Zigbee senzore upisuješ sa stranice uređaja.',
    bleHint: 'Kad ovaj most radi na uređaju, BLE senzore upisuješ sa stranice uređaja.',
    stateInstalling: 'instalira se',
    stateActive: 'radi',
    stateDisabled: 'isključen',
    stateError: 'greška',
  },
  wifi: {
    title: 'Wi-Fi',
    action: 'Wi-Fi',
    unsupported:
      'Ovaj uređaj još nije javio podršku za daljinsko upravljanje Wi-Fi mrežama. Pojavit će se kad uređaj pokrene firmver koji to podržava i javi se.',
    saved: 'Spremljene mreže',
    none: 'Nema javljenih mreža',
    connected: 'Povezan',
    forget: 'Zaboravi',
    lastNetwork:
      'Uređaj uvijek zadržava barem jednu mrežu. Dodaj drugu prije nego što zaboraviš ovu; inače je može promijeniti samo njegova stranica za postavljanje.',
    reportedAt: 'Prema javljanju uređaja {time}',
    add: 'Dodaj mrežu',
    ssid: 'Naziv mreže',
    ssidTooLong: 'Najviše 32 bajta.',
    open: 'Otvorena mreža (bez lozinke)',
    password: 'Lozinka',
    passwordHelp: 'Od 8 do 63 znaka. Dodavanje već spremljenog naziva zamjenjuje njegovu lozinku.',
    sealedNote:
      'Lozinka se šifrira u ovom pregledniku ključem koji ima samo uređaj. Poslužitelj je sprema i prosljeđuje, ali je ne može pročitati, i briše je čim je poslana.',
    addButton: 'Dodaj mrežu',
    sealUnavailable: 'Ovaj preglednik ovdje ne može šifrirati lozinku. Otvori aplikaciju preko HTTPS-a.',
    changes: 'Nedavne promjene',
    changeAdd: 'Dodaj {ssid}',
    changeRemove: 'Zaboravi {ssid}',
    changesHint:
      'Uređaj u dubokom snu preuzima promjene pri sljedećem buđenju; promjena koja nije isporučena unutar sat vremena istječe.',
    changesHintAlwaysOn:
      'Uređaj je povezan i preuzima promjene u nekoliko sekundi; promjena koja nije isporučena unutar sat vremena istječe.',
    state: {
      queued: 'Na čekanju',
      sent: 'Poslano',
      applied: 'Primijenjeno',
      expired: 'Isteklo',
    },
  },
  zigbee: {
    title: 'Zigbee senzori',
    action: 'Zigbee senzori',
    intro:
      'Upiši Zigbee senzor preko ovog pristupnika. Unesi EUI-64 i instalacijski kod s naljepnice senzora, zatim uključi senzor u roku od tri minute.',
    gatewayNote: 'Pristupnik mora pokretati modul Zigbee mosta u stalno uključenom načinu rada.',
    eui64: 'EUI-64',
    eui64Help: '16 heksadecimalnih znamenki s naljepnice',
    installCode: 'Instalacijski kod',
    installCodeHelp: 'S naljepnice, uključujući kontrolni zbroj',
    name: 'Naziv (neobavezno)',
    enroll: 'Upiši senzor',
    enrolling: 'Upisivanje…',
    invalidEui64: 'Koristi 16 heksadecimalnih znamenki.',
    invalidCode: 'Koristi 16, 20, 28 ili 36 heksadecimalnih znamenki.',
    requested: 'Pristupnik otvara mrežu. Sada uključi senzor.',
    history: 'Upisi',
    empty: 'Preko ovog pristupnika još nije upisan nijedan senzor.',
    pending: 'Čeka se senzor',
    completed: 'Upisan',
    expired: 'Isteklo',
    openSensor: 'Otvori senzor',
    notGateway: 'Ovaj uređaj ne pokreće modul Zigbee mosta.',
  },
  ble: {
    title: 'BLE senzori',
    action: 'BLE senzori',
    intro:
      'Upiši BLE senzor preko ovog pristupnika. Unesi adresu i ključ s naljepnice senzora, zatim uključi senzor u roku od deset minuta. Upisuje ga prvo mjerenje koje se otvara ovim ključem.',
    gatewayNote: 'Pristupnik mora pokretati modul BLE mosta u stalno uključenom načinu rada.',
    address: 'Adresa',
    addressHelp: '12 heksadecimalnih znamenki s naljepnice, s dvotočkama ili bez njih',
    key: 'Ključ',
    keyHelp: '32 heksadecimalne znamenke s naljepnice. Sprema se šifriran i više se ne prikazuje.',
    name: 'Naziv (neobavezno)',
    enroll: 'Upiši senzor',
    enrolling: 'Upisivanje…',
    invalidAddress: 'Koristi 12 heksadecimalnih znamenki.',
    invalidKey: 'Koristi 32 heksadecimalne znamenke.',
    requested: 'Čeka se prvo mjerenje senzora. Sada ga uključi.',
    history: 'Upisi',
    empty: 'Preko ovog pristupnika još nije upisan nijedan BLE senzor.',
    pending: 'Čeka se senzor',
    completed: 'Upisan',
    expired: 'Isteklo',
    openSensor: 'Otvori senzor',
    notGateway: 'Ovaj uređaj ne pokreće modul BLE mosta ili je senzor već upisan.',
    notConfigured: 'Upis BLE senzora još nije postavljen na ovom poslužitelju.',
  },
  configure: {
    title: 'Postavke uređaja',
    action: 'Postavke',
    intro:
      'Rad i Moduli zajedno čine konfiguraciju uređaja. Svako spremanje na bilo kojoj od tih kartica postaje nova numerirana revizija koja se šalje uređaju; traka ispod pokazuje radi li uređaj već s njom. Wi-Fi mreže šalju se zasebno.',
    tabs: {
      operation: 'Rad',
      modules: 'Moduli',
      wifi: 'Wi-Fi',
    },
  },
  config: {
    timezone: 'Vremenska zona',
    timezoneHelp:
      'Lokalno vrijeme uređaja, za module koji rade u određeno doba dana, na primjer pravilo koje uključuje u 7:00. Prazno znači UTC.',
    timezoneUtc: 'UTC',
    timezoneNone: 'Nema takve vremenske zone',
    timezoneUse: 'Koristi {zone}',
    title: 'Rad',
    notConfigured: 'Još nije konfiguriran',
    notConfiguredHint: 'Odaberi kako uređaj radi i spremi; time mu šalješ prvu konfiguraciju.',
    operationMode: 'Način rada',
    deepSleep: 'Duboki san',
    alwaysOn: 'Stalno uključen',
    intervalSeconds: 'Interval očitanja (sekunde)',
    intervalDeepSleepHelp:
      'Koliko se često uređaj budi, očitava sve module i javlja. Između toga spava, što štedi energiju, pa promjene stižu tek kad se probudi.',
    intervalAlwaysOnHelp:
      'Koliko često uređaj očitava sve module i javlja. Stalno je povezan pa promjene stižu u nekoliko sekundi, a brojači i izlazi rade i između očitanja.',
    intervalRange: 'Dopušteno za ovaj način rada: {min}–{max} sekundi.',
    deepSleepBlocked:
      'Duboki san nije dostupan dok je uključen modul {names}, jer on treba uređaj stalno budan. Najprije ga isključi na kartici Moduli.',
    deepSleepUnavailable: 'Duboki san (nije dostupan uz {names})',
    openModules: 'Otvori Module',
    rejected: 'Poslužitelj nije prihvatio ovu promjenu',
    desiredState: 'Kako uređaj radi',
    otaKept: 'Ažuriranje firmvera čeka ovaj uređaj; spremanje ga zadržava.',
    save: 'Spremi',
    saving: 'Spremanje…',
    saved: 'Spremljeno kao revizija {revision}. Traka iznad pokazuje kad uređaj počne raditi s njom.',
    conflictHelp:
      'Netko je spremio noviju reviziju dok si uređivao. Sada je prikazana; ponovi svoju promjenu.',
    unchanged: 'Nema promjena za spremanje.',
    loading: 'Učitavanje…',
  },
  delivery: {
    title: 'Isporuka konfiguracije',
    none: 'Konfiguracija još nije spremljena. Spremanje na kartici Rad ili Moduli šalje uređaju prvu.',
    sending: 'Spremljeno. Šalje se uređaju…',
    sentSleeping: 'Poslano. Uređaj spava između očitanja pa će to preuzeti kad se sljedeći put probudi.',
    sentConnected: 'Poslano. Uređaj je stalno povezan i potvrđuje promjenu u nekoliko sekundi.',
    applying: 'Uređaj to sada primjenjuje…',
    running: 'Uređaj je ažuran: radi sa spremljenom konfiguracijom.',
    failed: 'Uređaj nije mogao primijeniti spremljenu konfiguraciju ({code}) i radi s onim što je imao.',
    showDetails: 'Detalji',
    hideDetails: 'Sakrij detalje',
    explained:
      'Svako spremanje je numerirana revizija koja se šalje uređaju. Da uređaj radi s njom potvrđuje tek njegovo vlastito javljanje; do tada poslužitelj to ne može znati.',
    onDevice: 'Na uređaju',
    upToDate: 'Ažurno',
    behind: 'Starije od spremljenog',
    savedAt: 'Spremljeno',
    sentAt: 'Poslano uređaju',
    notSent: 'Još nije poslano',
    notReported: 'Još nije javljeno',
    deviceMode: 'Način rada na uređaju',
    firmware: 'Firmver',
    reportedAt: 'Uređaj se zadnje javio',
    lastFailure: 'Zadnja greška',
    lastFailureValue: 'Uređaj je odbio spremljenu konfiguraciju ({code})',
    revisions: 'Brojevi revizija',
    revisionPair: 'Spremljeno {saved}, uređaj radi {device}',
    revisionOnly: 'Spremljeno {saved}, ništa još nije primijenjeno',
    reportHint: 'Ovo je zadnje javljanje samog uređaja; ne dokazuje da je uređaj sada povezan.',
    reportHintMissing: 'Uređaj još nije javio što radi, pa nije poznato je li ažuran.',
  },
  onboarding: {
    elsewhereTitle: 'Ovaj uređaj pripada drugom računu',
    elsewhereBody:
      'Njegov vlasnik ga najprije mora ukloniti iz svog računa. Zatim uzmite novi kôd i ponovno ga uparite.',
    stepOf: 'Korak {step} od {total}',
    next: 'Dalje',
    back: 'Natrag',
    codeTitle: 'Preuzmi kod za povezivanje',
    codeBody:
      'Ovaj jednokratni kod povezuje uređaj s tvojim računom. Kopiraj ga sada: zalijepit ćeš ga na uređaju u 4. koraku.',
    getCode: 'Preuzmi kod',
    codeExpires: 'Kod vrijedi do {time}.',
    powerTitle: 'Uključi uređaj',
    powerBody: 'Novi uređaj nekoliko sekundi nakon uključivanja otvara vlastitu Wi-Fi mrežu za postavljanje.',
    powerHint:
      'Već je bio postavljen? Drži tipku za postavljanje dok ga uključuješ, dok svjetlo ne postane plavo.',
    joinTitle: 'Spoji se na Wi-Fi uređaja',
    joinBody: 'Otvori kameru na mobitelu, usmjeri je na QR kod na naljepnici uređaja i dodirni Spoji.',
    joinHint:
      'Nema QR koda? U postavkama Wi-Fi mreže spoji se na mrežu čiji naziv počinje sa Sensing- i upiši lozinku s naljepnice.',
    joined: 'Spojen sam',
    connectTitle: 'Poveži ga sa svojom Wi-Fi mrežom',
    connectBody:
      'Stranica za postavljanje otvara se sama. Odaberi svoju Wi-Fi mrežu, upiši njezinu lozinku, zalijepi kod i dodirni Spremi i poveži.',
    connectHint: 'Stranica se nije otvorila? U pregledniku otvori <link>http://192.168.4.1</link>.',
    connected: 'Gotovo',
    waitTitle: 'Još malo',
    waitBody:
      'Uređaj se spaja na tvoju Wi-Fi mrežu i javlja tvom računu. Mobitel se sam vraća na tvoju Wi-Fi mrežu.',
    waiting: 'Čekam uređaj…',
    waitOffline:
      'Poslužitelj još nije dostupan. Ako je mobitel još na Wi-Fi mreži uređaja, vrati ga na svoju.',
    expiredTitle: 'Kod je istekao',
    expiredBody:
      'Preuzmi novi kod i ponovno ga upiši na stranici za postavljanje. Uređaj pamti Wi-Fi podatke koje si mu dao.',
    failedTitle: 'Taj kod nije uspio',
    failedBody: 'Preuzmi novi kod i ponovno ga upiši na stranici za postavljanje.',
    newCode: 'Preuzmi novi kod',
    doneTitle: 'Uređaj je spreman',
    doneBody: 'Povezan je s tvojim računom. Daj mu naziv po kojem ćeš ga prepoznati.',
    nameLabel: 'Naziv',
    namePlaceholder: 'Staklenik',
    chooseModules: 'Odaberi što mjeri',
    finish: 'Završi',
    welcomeTitle: 'Dobro došao u Sensing',
    welcomeBody:
      'Za početak dodaj svoj prvi uređaj. Traje nekoliko minuta; pripremi uređaj i njegovu naljepnicu.',
    welcomeStart: 'Dodaj uređaj',
    welcomeExternal: 'Radije poveži vanjski izvor',
  },
  pairing: {
    title: 'Dodaj uređaj',
    copy: 'Kopiraj kod',
  },
  external: {
    title: 'Stvori vanjski izvor',
    description:
      'Vanjski izvor je bilo koji program, usluga ili uređaj koji sam šalje očitanja u Sensing: skripta, vremenska postaja, Node-RED, Home Assistant ili drugi oblak.',
    name: 'Naziv izvora',
    nameHelp: 'Prikazuje se u izvorima i na nadzornoj ploči. Možeš ga kasnije preimenovati.',
    namePlaceholder: 'Vremenska postaja na krovu',
    connector: 'Kako će slati podatke?',
    connectorHelp:
      'Odaberi što pošiljatelj zna. Kasnije se ne može promijeniti; umjesto toga stvori novi izvor.',
    connectorHttp: 'HTTP slanje',
    connectorHttpHelp:
      'Za svako očitanje šalje HTTPS POST zahtjev s tokenom u zaglavlju. Najbolje za skripte, cron poslove, funkcije u oblaku i webhookove.',
    connectorMqtt: 'MQTT',
    connectorMqttHelp:
      'Svako očitanje objavljuje kao MQTT poruku preko TLS-a, uz korisničko ime i lozinku. Najbolje za uređaje i alate koji već govore MQTT.',
    channels: 'Kanali',
    channelsHelp:
      'Kanal je jedna vrsta vrijednosti koju izvor šalje, npr. temperatura. Svako očitanje navodi svoj kanal, a svaki kanal postaje zaseban tok podataka s grafom.',
    keyHelp:
      'Ključ: naziv koji pošiljatelj stavlja u channel_key, npr. temperature. Samo slova, znamenke, _ . i -.',
    nameColumnHelp: 'Naziv: ono što aplikacija prikazuje, npr. Temperatura dnevnog boravka. Neobavezno.',
    unitHelp:
      'Jedinica: jedinica koju svako očitanje mora navesti, npr. degC, percent ili hPa. Kasnije se ne može mijenjati.',
    typeHelp:
      'Vrsta: broj za mjerenja, cijeli broj za brojanja, uključeno/isključeno za stanja da/ne, tekst za stanja.',
    presets: 'Kreni od:',
    preset: {
      weather: 'Vremenska postaja',
      power: 'Brojilo snage',
      single: 'Jedna vrijednost',
    },
    presetNames: {
      temperature: 'Temperatura',
      humidity: 'Vlažnost',
      pressure: 'Tlak',
      power: 'Snaga',
      energy: 'Energija',
    },
    channelKey: 'Ključ',
    channelName: 'Naziv',
    channelNamePlaceholder: 'Neobavezno',
    channelUnit: 'Jedinica',
    channelType: 'Vrsta',
    channelTypeNumber: 'Broj',
    channelTypeInteger: 'Cijeli broj',
    channelTypeBoolean: 'Uključeno/isključeno',
    channelTypeString: 'Tekst',
    addChannel: 'Dodaj kanal',
    remove: 'Ukloni',
    removeChannel: 'Ukloni kanal {index}',
    undeclaredHint:
      'Očitanje za ključ koji nisi naveo stvara taj kanal s jedinicom i vrstom s kojom je stiglo.',
    channelKeyRequired: 'Svaki kanal treba ključ.',
    channelKeyFormat: 'Ključevi kanala smiju sadržavati samo slova, znamenke, _ . i -, do 64 znaka.',
    channelUnitRequired: 'Svaki kanal treba jedinicu.',
    channelKeyUnique: 'Ključevi kanala moraju biti jedinstveni.',
    nameRequired: 'Upiši naziv izvora.',
    atLeastOneChannel: 'Navedi barem jedan kanal.',
    create: 'Stvori izvor',
    creating: 'Stvaranje…',
    createError: 'Izvor nije stvoren.',
    createdTitle: 'Izvor je stvoren',
    createdDescription: 'Kopiraj token, a zatim usmjeri pošiljatelja na adresu ispod.',
    token: 'Token',
    tokenOnce:
      'Token se prikazuje samo jednom i ne može se ponovno dohvatiti. Spremi ga sada; ako ga izgubiš, izdaj novi na stranici izvora.',
    tokenKeepPrivate:
      'Svatko s tokenom može slati podatke kao ovaj izvor. Ne stavljaj ga u poveznice, zapise ni snimke zaslona.',
    copyToken: 'Kopiraj token',
    goToSource: 'Otvori izvor',
    backToSources: 'Natrag na izvore',
  },
  intake: {
    title: 'Slanje podataka',
    connector: 'Šalje preko',
    lastSample: 'Posljednje primljeno očitanje',
    noSampleYet: 'Još ništa',
    tokenUsed: 'Token posljednji put korišten',
    tokenNeverUsed: 'Još nije',
    noToken: 'Nema aktivnog tokena',
    newToken: 'Novi token',
    newTokenTitle: 'Izdati novi token?',
    newTokenBodyHttp:
      'Trenutačni token odmah prestaje vrijediti. Ažuriraj pošiljatelja novim tokenom, koji se prikazuje samo jednom.',
    newTokenBodyMqtt:
      'Trenutačna lozinka prestaje vrijediti za nova spajanja; klijent koji je sada spojen ostaje spojen dok se ne spoji ponovno. Novi token prikazuje se samo jednom.',
    newTokenConfirm: 'Zamijeni token',
    newTokenShown: 'Tvoj novi token. Prikazuje se samo sada; naredbe ispod ga sadrže.',
    rejectionsTitle: 'Nedavno odbijena očitanja',
    rejectionsHint:
      'Ova očitanja su stigla, ali nisu spremljena. Popravi pošiljatelja i pošalji ih ponovno s istim ID-om mjerenja.',
    rejectedAt: 'Kada',
    reason: 'Zašto',
    measurement: 'ID mjerenja',
    reasons: {
      malformed: 'Nije ispravno očitanje: neko polje nedostaje, krivo je napisano ili je pogrešne vrste.',
      unsupported_version: 'protocol_version mora biti 0.',
      invalid_time:
        'Vrijeme ne odgovara time_quality: navedi observed_at s vremenskom zonom, ili null uz unknown.',
      invalid_value: 'Vrijednost ne odgovara vrsti kanala ili se ne može točno spremiti.',
      oversized: 'Poruka je prevelika.',
      channel_limit: 'Izvor je dosegao najveći broj kanala pa je novi ključ odbijen.',
      conflicting_content:
        'Ovaj ID mjerenja već je korišten za drugo očitanje. Za svako očitanje koristi novi ID.',
      channel_mismatch:
        'Jedinica ili vrsta razlikuje se od kanalove. Šalji jedinicu s kojom je kanal stvoren.',
      source_unowned: 'Izvor je uklonjen.',
    },
    guideTitle: 'Kako slati podatke',
    whereTitle: 'Kamo slati',
    httpWhere: 'Pošalji jedan HTTPS zahtjev po očitanju:',
    mqttWhere:
      'Spoji se preko TLS-a. Broker koristi običan javni certifikat pa vlastiti certifikat nije potreban.',
    method: 'Metoda',
    url: 'URL',
    header: 'Zaglavlje',
    headerValue: 'Vrijednost zaglavlja',
    theToken: 'Tvoj token',
    contentType: 'Content-Type',
    host: 'Poslužitelj',
    port: 'Port',
    portTls: '{port} (TLS)',
    username: 'Korisničko ime',
    password: 'Lozinka',
    clientId: 'ID klijenta',
    clientIdHint: 'Bilo što jedinstveno, npr. korisničko ime',
    topic: 'Tema',
    qos: 'QoS',
    qosHint: '1, bez zadržavanja',
    whatTitle: 'Što slati',
    oneSampleHttp: 'Tijelo je jedno očitanje kao JSON. Za više vrijednosti pošalji jedan zahtjev po kanalu.',
    oneSampleMqtt:
      'Svaka poruka je jedno očitanje kao JSON. Za više vrijednosti objavi jednu poruku po kanalu.',
    field: 'Polje',
    meaning: 'Značenje',
    fieldProtocol: 'Uvijek 0.',
    fieldMeasurement:
      'Tvoj ID ovog očitanja, jedinstven unutar izvora. Pri ponovnom slanju pošalji isti ID, da se očitanje nikad ne spremi dvaput; vrijeme plus ključ kanala dobro funkcionira.',
    fieldChannel: 'Ključ kanala.',
    fieldValue: 'Očitanje: broj, cijeli broj, true ili false, ili tekst, prema vrsti kanala.',
    fieldUnit: 'Točno jedinica kanala.',
    fieldObserved:
      'Kada je izmjereno, u obliku ISO 8601 s vremenskom zonom, npr. 2026-10-19T12:00:00Z. Ako nije poznato, null.',
    fieldQuality:
      'synchronized ako sat pošiljatelja postavlja NTP, estimated ako može odstupati, unknown kad je observed_at null.',
    tryTitle: 'Isprobaj',
    exampleChannel: 'Primjer za kanal',
    payload: 'Očitanje',
    curl: 'Pomoću curla',
    mosquitto: 'Pomoću mosquitto_pub',
    copy: 'Kopiraj',
    placeholderHint: 'Zamijeni {placeholder} svojim tokenom.',
    httpResponses:
      'Odgovori: 200 spremljeno (ili duplicate, već spremljeno); 400 nije ispravno očitanje; 401 pogrešan token; 422 odbijeno, vidi razlog; 429 prebrzo, pokušaj kasnije; 503 pokušaj ponovno.',
    mqttResponses:
      'Broker prihvaća svaku dopuštenu poruku; očitanje koje bude odbijeno nakon toga navedeno je na stranici izvora s razlogom.',
  },
  admin: {
    title: 'Administracija',
    description: 'Upravljaj računima i uređajima, djeluj kao drugi račun i pregledaj revizijski dnevnik.',
    tabs: {
      users: 'Računi',
      modules: 'Moduli',
      devices: 'Uređaji',
      audit: 'Revizijski dnevnik',
      firmware: 'Firmver',
    },
    firmware: {
      title: 'Izdanja firmvera',
      intro:
        'Izradi i potpiši izdanje na svom računalu naredbom scripts/device.sh release u repozitoriju firmvera, zatim učitaj sliku i njezin zapis .release.json. Vlasnicima uređaja sa starijom verzijom nudi se na stranici uređaja; ništa se ne instalira dok ga ne pokrenu.',
      image: 'Slika (.bin)',
      record: 'Zapis izdanja (.release.json)',
      publish: 'Objavi',
      publishing: 'Objavljivanje…',
      recordInvalid: 'Ta datoteka nije zapis izdanja iz device.sh release.',
      published: 'Izdanje {version} je objavljeno.',
      empty: 'Još nema izdanja firmvera',
      columnVersion: 'Verzija',
      columnInstallsOn: 'Instalira se na',
      columnImage: 'Slika',
      columnPublished: 'Objavljeno',
      columnStatus: 'Stanje',
      columnActions: 'Radnje',
      sequence: 'Ponuda {sequence}',
      layout: 'raspored {layout}',
      size: '{size} KiB',
      windowAny: 'Svaku stariju verziju',
      windowFrom: '{min} i novije',
      windowUpTo: 'Do {max}',
      windowBetween: 'Od {min} do {max}',
      offered: 'Nudi se',
      withdrawn: 'Povučeno',
      withdraw: 'Povuci',
      restore: 'Vrati',
      withdrawHint: 'Povlačenje zaustavlja nove ponude; već zatražena ažuriranja se nastavljaju.',
    },
    devices: {
      title: 'Upisani uređaji',
      intro:
        'Uređaj se može upariti kad je njegov tvornički certifikat upisan ovdje. U repozitoriju firmvera, scripts/device.sh manufacture <id> izrađuje certifikat, zapisuje tvorničku particiju i navodi datoteku koju treba odabrati.',
      enroll: 'Upiši uređaj',
      publicId: 'Javni ID',
      publicIdHint: 'Kako je zapisan u tvorničkoj particiji, na primjer sen-0001.',
      certificate: 'Tvornički certifikat (.pem)',
      certificateHint: 'devices/<id>.pem u PKI direktoriju uređaja.',
      enrolled: '{id} je upisan.',
      certificateAdded: '{id} je dobio još jedan certifikat.',
      alreadyEnrolled: '{id} već ima ovaj certifikat.',
      empty: 'Još nema upisanih uređaja.',
      columnDevice: 'Uređaj',
      columnOwner: 'Vlasnik',
      columnSeen: 'Zadnji kontakt',
      columnFirmware: 'Firmver',
      columnCertificates: 'Certifikati',
      columnActions: 'Radnje',
      unowned: 'Bez vlasnika',
      neverSeen: 'Nikad',
      certificateActive: 'Aktivan',
      certificateRevoked: 'Opozvan: {reason}',
      reset: 'Resetiraj',
      resetTitle: 'Resetirati {id}?',
      resetBody:
        'Kad se sljedeći put spoji, uređaj briše svoje postavke Wi-Fi mreže, module i spremljena očitanja te otvara postavljanje. Zadržava vlasnika: ponovno uparivanje s tog računa vraća njegovu konfiguraciju.',
      resetQueued: '{id} će se resetirati kad se sljedeći put spoji.',
      revoke: 'Opozovi',
      revokeTitle: 'Opozvati ovaj certifikat?',
      revokeBody:
        'Uređaj se njime više ne može upariti ni spojiti. Ovo se ne može poništiti; novi certifikat traži novu tvorničku particiju.',
      reason: 'Razlog',
      reasonLost: 'Izgubljen',
      reasonCompromised: 'Kompromitiran',
      reasonRetired: 'Povučen iz upotrebe',
    },
    modules: {
      title: 'Katalog modula',
      intro:
        'Objavi module izgrađene i potpisane alatom smf (`smf catalog` gradi sve). Odaberi .smpk paket i njegov .artifact.json zapis; poslužitelj provjerava potpis prema pouzdanim ključevima kataloga i sprema paket.',
      package: 'Paket (.smpk)',
      record: 'Zapis potpisa (.artifact.json)',
      publish: 'Objavi',
      publishing: 'Objavljivanje…',
      published: 'Objavljeno: {module} {version}',
      alreadyPublished: '{module} {version} već je objavljen s istim sadržajem.',
      recordInvalid: 'To nije .artifact.json zapis iz alata smf.',
      empty: 'Još nema objavljenih modula.',
      columnModule: 'Modul',
      columnVersion: 'Verzija',
      columnProvider: 'Izvor',
      columnPublished: 'Objavljeno',
      columnStatus: 'Stanje',
      columnActions: 'Radnje',
      selectable: 'Dostupan',
      deprecated: 'Zastario',
      builtIn: 'Ugrađen',
      signed: 'Potpisani paket',
      deprecate: 'Označi zastarjelim',
      restore: 'Vrati',
      deprecateHint:
        'Zastarjela verzija ostaje na uređajima koji je već koriste, ali se ne može ponovno odabrati.',
    },
    usersTitle: 'Računi',
    usersEmpty: 'Nema vidljivih računa.',
    usersEmptyHint: 'Računi se pojavljuju kada se korisnici prijave.',
    columnId: 'Račun',
    columnRole: 'Uloga',
    columnStatus: 'Status',
    columnCreatedAt: 'Stvoren',
    columnActions: 'Radnje',
    statusActive: 'Aktivan',
    statusDisabled: 'Onemogućen',
    statusDeleted: 'Izbrisan',
    columnAccess: 'Pristup',
    approved: 'Odobren',
    awaitingApproval: 'Čeka odobrenje',
    approve: 'Odobri',
    revokeApproval: 'Povuci odobrenje',
    deleteUser: 'Izbriši',
    deleteUserTitle: 'Izbrisati ovaj račun?',
    deleteUserBody:
      'Izbrisati {target} i sve što posjeduje, odmah i zauvijek? Njegovi se uređaji oslobađaju i resetiraju.',
    requireApproval: 'Zatvorena beta: novi računi trebaju odobrenje',
    requireApprovalHint:
      'Svatko se može prijaviti putem Googlea ili Applea, čime se račun stvara. Dok ga ne odobriš, vidi samo da čeka. Administratori nikad ne čekaju.',
    changeRole: 'Promijeni ulogu',
    roleDialogTitle: 'Promjena uloge',
    roleDialogBody: 'Postaviti {target} na {role}?',
    grantAdminTitle: 'Dodjela administratorskog pristupa',
    grantAdminBody: 'Postaviti {target} za administratora? To se ne odnosi samo na njegov vlastiti račun.',
    grantAdminList:
      'Administrator može izlistati sve račune na ovoj instalaciji, odobravati i ukidati odobrenja, mijenjati svačiju ulogu, djelovati kao bilo koji račun, upisivati i opozivati uređaje, objavljivati katalog modula i firmware te brisati račune.',
    grantAdminSelf: 'Ovo je tvoj vlastiti račun, pa promjena vrijedi od sljedećeg zahtjeva.',
    makeAdmin: 'Postavi za administratora',
    makeOwner: 'Postavi za vlasnika',
    roleSet: 'Uloga je promijenjena',
    roleError: 'Ulogu nije bilo moguće promijeniti.',
    roleNoop: 'Ovaj račun već ima tu ulogu.',
    impersonate: 'Djeluj kao ovaj račun',
    impersonateConfirmTitle: 'Djelovati kao drugi račun?',
    impersonateConfirmBody:
      'Djelovat ćeš kao {target}. Svaka promjena bilježi se u revizijski dnevnik. Tvoje administratorske radnje skrivene su do zaustavljanja.',
    selfDemotionWarning: 'Promjena vlastite uloge odmah uklanja administratorski pristup.',
    auditTitle: 'Revizijski dnevnik',
    auditEmpty: 'Još nema revizijskih zapisa.',
    auditEmptyHint:
      'Promjene uloga, predstavljanje, radnje nad uređajima i promjene pod predstavljanjem pojavljuju se ovdje.',
    auditColumnActor: 'Izvršitelj',
    auditColumnEffective: 'Aktivni račun',
    auditColumnTarget: 'Cilj',
    auditActionRoleSet: 'Uloga promijenjena',
    auditActionImpersonateStart: 'Predstavljanje započeto',
    auditActionImpersonateStop: 'Predstavljanje zaustavljeno',
    auditActionImpersonateMutation: 'Promjena pod predstavljanjem',
    auditActionDeviceEnroll: 'Uređaj upisan',
    auditActionDeviceRevoke: 'Certifikat opozvan',
    auditActionDeviceReset: 'Uređaj resetiran',
    auditActionApprovalSet: 'Odobrenje promijenjeno',
    auditActionAccessSet: 'Zatvorena beta promijenjena',
    auditActionAccountDelete: 'Račun izbrisan',
    auditActionModulePublish: 'Modul objavljen',
    auditActionFirmwarePublish: 'Izdanje firmvera objavljeno',
    auditActionUnknown: '{action}',
    auditFactRole: 'Uloga',
    auditFactApproved: 'Odobreno',
    auditFactRequireApproval: 'Potrebno odobrenje',
    auditFactFingerprint: 'Otisak',
    auditFactCertificateStatus: 'Certifikat',
    auditFactReason: 'Razlog',
    auditFactDevice: 'Uređaj',
    auditFactRevision: 'Revizija',
    auditFactDigest: 'Sažetak',
    auditFactSize: 'Veličina',
    auditFactEpoch: 'Sigurnosna epoha',
    auditFactSigningKey: 'Ključ potpisa',
    auditFactSequence: 'Redni broj ponude',
    auditFactBoard: 'Ploča',
    auditStatus: 'HTTP {status}',
    auditNoFurtherDetails: 'Nema dodatnih pojedinosti.',
    auditShowRaw: 'Prikaži izvorni zapis',
    auditHideRaw: 'Sakrij izvorni zapis',
    accessTitle: 'Pravila prijave',
    accountActions: 'Račun',
    dangerZone: 'Opasna zona',
    moreActions: 'Više radnji',
    blockedWhileImpersonating: 'Administratorske radnje nisu dostupne tijekom predstavljanja.',
  },
  impersonation: {
    banner: 'Djeluješ kao {effective} (administrator {actor})',
    stop: 'Zaustavi predstavljanje',
    stopping: 'Zaustavljanje…',
    started: 'Sada djeluješ kao {target}',
    stopped: 'Predstavljanje je zaustavljeno',
    error: 'Predstavljanje nije bilo moguće započeti.',
    stopError: 'Predstavljanje nije bilo moguće zaustaviti.',
    resumed: 'Ova je sesija već djelovala kao drugi račun kad se aplikacija otvorila.',
  },
  install: {
    title: 'Instaliraj Sensing za nastavak',
    required: 'Na telefonu Sensing radi kao aplikacija.',
    iosShare: 'Dodirni Podijeli',
    iosShareHint: 'Nije na traci? Otvori',
    iosAdd: 'Dodirni Dodaj na početni zaslon',
    androidMenu: 'Dodirni izbornik preglednika',
    androidAdd: 'Dodirni Instaliraj aplikaciju ili Dodaj na početni zaslon',
    open: 'Otvori Sensing s početnog zaslona',
    menuHere: 'Izbornik',
    toolbarBelow: 'Podijeli je na alatnoj traci Safarija',
    featureReadings: 'Očitanja svih senzora uživo',
    featureDevices: 'Dodaj i postavi uređaje u nekoliko dodira',
    featureRemote: 'Mijenjaj module, Wi-Fi i ritam s bilo kojeg mjesta',
  },
  offline: {
    title: 'Nemaš vezu s internetom',
    body: 'Osnovni dio aplikacije je dostupan, ali podaci izvora se trenutno ne mogu učitati.',
    unavailable: 'Podaci nisu dostupni bez veze s internetom.',
    retry: 'Pokušaj ponovno',
    sessionUnconfirmed: 'Lokalno ste odjavljeni. Poslužitelj nije dosegnut pa sesija možda još vrijedi.',
  },
  removal: {
    action: 'Ukloni',
    archiveAction: 'Obriši',
    deviceTitle: 'Ukloniti ovaj uređaj?',
    externalTitle: 'Ukloniti ovaj izvor?',
    archiveTitle: 'Obrisati ovu povijest?',
    deviceBody:
      'Uređaj napušta vaš račun i prestaje pokretati svoje module. Nakon toga ga bilo tko može upariti kôdom.',
    externalBody: 'Izvor napušta vaš račun i njegov token prestaje vrijediti.',
    archiveBody: 'Brišu se svi tokovi i očitanja u njoj.',
    dataLabel: 'Njegova očitanja',
    keep: 'Zadrži ih',
    keepHint: 'Sele se u „Uklonjeno”, gdje ih i dalje možete čitati ili obrisati.',
    delete: 'Obriši ih',
    deleteHint: 'Brišu se svi tokovi i očitanja ovog izvora.',
    releaseAction: 'Oslobodi',
    releaseTitle: 'Osloboditi ovaj uređaj?',
    releaseBody:
      'Uređaj napušta vaš račun. Kad se sljedeći put spoji, briše svoje postavke Wi-Fi mreže, module i spremljena očitanja te otvara postavljanje, pa ga bilo tko može upariti kôdom.',
    releaseOffline: 'Ako je sada isključen, vratit će se na tvorničke postavke kad se sljedeći put spoji.',
    confirmRelease: 'Oslobodi',
    confirmReleaseDelete: 'Oslobodi i obriši',
    irreversible: 'Ovo se ne može poništiti.',
    confirmKeep: 'Ukloni',
    confirmDelete: 'Ukloni i obriši',
    archiveConfirm: 'Obriši',
  },
  deletion: {
    action: 'Obriši…',
    title: 'Brisanje podataka: {name}',
    what: 'Što obrisati',
    before: 'Očitanja prije datuma',
    date: 'Prije',
    dateHint: 'Očitanja od tog dana nadalje ostaju.',
    all: 'Sva očitanja',
    allHint: 'Tok ostaje i nova očitanja i dalje stižu.',
    stream: 'Cijeli tok',
    streamHint: 'Tok i sva njegova očitanja.',
    streamActiveHint: 'Tok i sva njegova očitanja. Izvor ga još šalje pa kreće ispočetka, prazan.',
    confirm: 'Obriši',
    done: { one: 'Obrisano je {count} očitanje.', other: 'Obrisano je {count} očitanja.' },
  },
  controls: {
    title: 'Upravljanje',
    applied: 'Uređaj radi s ovim postavkama.',
    pending: 'Čeka se da uređaj primijeni zadnju promjenu…',
    auto: 'Automatski',
    on: 'Uključeno',
    off: 'Isključeno',
    saving: 'Spremanje',
  },
  errors: {
    generic: 'Nešto je pošlo po zlu. Pokušaj ponovno.',
    invalid_request: 'Zahtjev nije bio valjan.',
    unauthenticated: 'Tvoja sesija više nije valjana. Prijavi se ponovno.',
    forbidden: 'To ti nije dopušteno.',
    not_found: 'Nismo mogli pronaći ono što tražiš.',
    conflict: 'Ovo se promijenilo otkad si učitao. Sada je prikazana najnovija verzija; pokušaj ponovno.',
    rate_limited: 'Previše zahtjeva. Pričekaj trenutak i pokušaj ponovno.',
    claim_rejected: 'Kod za uparivanje je odbijen, istekao ili već iskorišten.',
    device_owned_elsewhere: 'Ovaj uređaj pripada drugom računu. Njegov vlasnik ga najprije mora ukloniti.',
    payload_too_large: 'Zahtjev je bio prevelik.',
    unprocessable: 'Zahtjev nije bilo moguće obraditi kako je poslan.',
    internal_error: 'Usluga je imala problem. Pokušaj ponovno.',
    unavailable: 'Usluga je privremeno nedostupna. Pokušaj ponovno.',
  },
  a11y: {
    skipToContent: 'Preskoči na glavni sadržaj',
    currentPage: 'Trenutna stranica',
    loadingData: 'Učitavanje podataka',
    impersonationBanner: 'Obavijest o predstavljanju',
    chartImage: 'Grafikon povijesti',
  },
};
